export const ALL_GROUPS_GROUP = -1;
